import {Box} from "@mui/material";

import {DefaultContainer} from "../../../../components/common/DefaultContainer";
import {DialogHeading} from "../../AddAndUpdateSaas/dialogs/misc/styles";
import {usePortalContext} from "../../../../hooks/PortalContext";
import {portalUserRoles} from "../../../../utils/constants";
import {ClientNotificationSettings} from "./ClientNotificationSettings";

// Super admins can change the settings of any client, account admins those of
// the clients they administer.
export const canEditClientNotificationSettings = (
  highestPrivilege: string,
  clientRoles: { client: { id: string }, role: string }[],
  clientId: string,
) =>
  highestPrivilege === portalUserRoles.admin ||
  clientRoles.some(cr => cr.client.id === clientId && cr.role === portalUserRoles.orgAdmin);

// The notification settings of the current client
export const NotificationPanel = () => {
  document.title = 'Notifications - Detexian';

  const {clientInfo, loggedInUser} = usePortalContext();

  return <DefaultContainer>
    <Box sx={{minWidth: '1000px', maxWidth: '1200px'}}>
      <DialogHeading>Notifications for {clientInfo.name}</DialogHeading>
      <ClientNotificationSettings
        userRole={loggedInUser.highestPrivilege}
        canEdit={canEditClientNotificationSettings(
          loggedInUser.highestPrivilege,
          loggedInUser.userInfo.clientRoles,
          clientInfo.id,
        )}
      />
    </Box>
  </DefaultContainer>;
};
